<script>
import "@plugins/maskmoney/jquery.priceformat.js"

export default {
	props: {
        value: [String,Number],
        autocomplete: {default:"on"},
    },
    mounted: function () {
        $(this.$el).val(this.value).priceFormat({
            prefix:'',
            centsSeparator: ',',
            thousandsSeparator: '.',
            centsLimit: 0,
            clearOnEmpty: true,
        }).trigger('keyup').keyup((e)=>{
            this.$emit('input', e.target.value)
            this.$emit('keyup', e.target.value)
        }).change((e)=>{
            this.$emit('change', e.target.value)
        });
    },
    watch: {
        value: function (value) {
            $(this.$el).val(value).trigger('keyup');
        }
    },
}
</script>

<template>
	<input type="text" :autocomplete="autocomplete">
</template>

